/**
 * Created by gusenlin on 2018/6/6.
 */
import config from 'config';
import store from '../vuex';
import { NativeService } from '@/service/native/nativePluginService';
import { Base64 } from 'js-base64';

export const getQueryString = (name, targetHref = window.location.href) => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let href = targetHref.split('#')[0];
  let r = href.substr(href.toString().indexOf('?') + 1).match(reg);
  if (r != null) {
    if (unescape(r[2]) === 'null') {
      return null;
    } else if (unescape(r[2]) === 'undefined') {
      return undefined;
    } else {
      return unescape(r[2]);
    }
  }
  return null;
};

/**
 * 从url中获取参数
 * @url string
 * @return obj 使用new方式获取url对象
 */
export function getUrlSearchParams(url) {
  return new UrlSearch(url);

  function UrlSearch(url) {
    let name, value, str, num;
    str = url ? url : window.location.href; //取得整个地址栏
    num = str.indexOf('?');
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
    let arr = str.split('&'); //各个参数放到数组里
    for (let i = 0; i < arr.length; i++) {
      num = arr[i].indexOf('=');
      if (num > 0) {
        name = arr[i].substring(0, num);
        value = arr[i].substr(num + 1);
        this[name] = value;
      }
    }
  }
}

export const isUIWebview = () => {
  let isUIWebview = getQueryString('isOldWebview');
  return isIOS() && isUIWebview === 'Y';
};

export const getEnvironmentType = (name) => {
  if (window.location.href.toLowerCase().indexOf('dd-trial') !== -1) {
    return 'dd';
  } else if (config.env === 'none') {
    return config.platform;
  } else {
    return getQueryString(name);
  }
};

export const getClientCode = () => {
  let loginType = getQueryString('loginType') || 'webapp';
  let clientCode = loginType ? loginType.toUpperCase() : '';
  if (clientCode.indexOf('WELINK') !== -1) {
    clientCode = 'WELINK';
  }
  return clientCode;
};

//获取代码所在的平台
export const getH5Platform = () => {
  let loginType = getQueryString('loginType');

  if (!loginType || loginType === '') {
    return 'webapp';
  }

  const platformMap = {
    wx: 'wx', //企业微信
    wxmp: 'wx', //微信服务号
    dd: 'dd', //钉钉
    operation: 'dd', //在运营系统扫码进入钉钉
    cd: 'cd', //汇联易App
    webapp: 'webapp', //汇联易在线H5
    feishu: 'lark', //飞书
    welink: 'welink', //welink
    yzj: 'yzj', //云之家
  };

  let platform = platformMap[loginType] || 'webapp';

  if (window.location.href.toLowerCase().indexOf('dd-trial') !== -1) {
    platform = 'dd';
  }
  return platform;
};

export const getSourceType = (name) => {
  let source = getEnvironmentType(name);
  if (source == 'dd' || window.location.href.toLowerCase().indexOf('dd-trial') !== -1) {
    return 'dingtalk';
  } else if (source == 'wx') {
    return 'wechat';
  }
};

export const isIOS = () => {
  var u = navigator.userAgent;
  var herf = location.href;
  let flag = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || !!u.match(/Mac OS X/); //ios终端; //ios终端
  //汇联易 iOS有个bug，userAgent 取到null的时候，就全部报错了，先修复下
  if (!flag) {
    flag =
      herf.indexOf('file:///var/mobile/Containers/Data/Application') > -1 &&
      herf.indexOf('/Library/WEBRESOURCEFILES/') > -1;
  }
  return flag;
};

export const isPC = () => {
  let userAgentInfo = navigator.userAgent;
  let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) >= 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

//阿里云，腾讯云，xxx云逻辑处理
export const getBaseUrl = () => {
  let { baseUrl, baseWechatServer = '', baseDingtalkServer = '' } = config;
  let href = window.location.href;
  let platform = getH5Platform();
  let loginType = getQueryString('loginType');
  let isTrial = getQueryString('isTrial');
  if (!loginType || loginType === '') {
    platform = '';
  }
  // 微信修改服务器
  if (platform === 'wx' && baseWechatServer && href.indexOf('wechat-tc.huilianyi.com') === -1) {
    baseUrl += baseWechatServer;
  }
  // 钉钉专属云不添加v1
  if (
    platform === 'dd' &&
    baseDingtalkServer &&
    (href.indexOf('.huilianyi.com') > -1 || href.indexOf('.yunmart.com') > -1)
  ) {
    baseUrl += baseDingtalkServer;
  }
  //在线的统一加上v1 本地项目不需要
  if (['lark', 'welink', 'yzj'].includes(platform)) {
    //飞书自建应用
    if (
      (platform === 'lark' && isTrial !== 'Y' && href.indexOf('huilianyi.com') > -1) ||
      ['welink', 'yzj'].includes(platform)
    ) {
      baseUrl += '/v1';
    }
  }

  let defaultBaseUrl = baseUrl;
  try {
    defaultBaseUrl = store.getters.getBaseUrl || baseUrl;
  } catch (e) {}
  // eslint-disable-next-line no-undef
  return MULTIPLE_CLOUD_BASE_URL || defaultBaseUrl;
};

// 判断是否是甄选的服务
export const isZhenxuanService = (url = '') => {
  return url.startsWith('/open');
};

// 获取甄选的baseUrl
export const getZhenxuanBaseUrl = () => {
  let { zhenxuanUrl = 'https://zhenxuan.huilianyi.com' } = config;
  return zhenxuanUrl;
};

//阿里云，腾讯云，xxx云逻辑处理
export const setBaseUrl = (baseUrl) => {
  // eslint-disable-next-line no-undef
  MULTIPLE_CLOUD_BASE_URL = baseUrl;
};

export const initStorage = (activatedDate) => {
  if (!activatedDate) {
    return;
  }

  try {
    let activateDate = new Date(activatedDate);
    if (activateDate <= new Date('2019/08/01')) {
      return;
    }
  } catch (e) {
    return;
  }

  NativeService()
    .getLocalStorageItem('hlyGuideFirstCreateDocument')
    .then((res) => {
      let firstCreateDocument = res;
      if (!res || res === '') {
        firstCreateDocument = 'Y';
      }
      store.commit('guide/setFirstCreateDocument', firstCreateDocument);
    });
  NativeService()
    .getLocalStorageItem('hlyGuideFirstImportExpense')
    .then((res) => {
      let firstImportExpense = res;
      if (!res || res === '') {
        firstImportExpense = 'Y';
      }
      store.commit('guide/setFirstImportExpense', firstImportExpense);
    });
  NativeService()
    .getLocalStorageItem('hlyGuideFirstEditDocument')
    .then((res) => {
      let firstEditDocument = res;
      if (!res || res === '') {
        firstEditDocument = 'Y';
      }
      store.commit('guide/setFirstEditDocument', firstEditDocument);
    });
  NativeService()
    .getLocalStorageItem('hlyGuideFirstOperationMore')
    .then((res) => {
      let firstOperationMore = res;
      if (!res && res === '') {
        firstOperationMore = 'Y';
      }
      store.commit('guide/setFirstOperationMore', firstOperationMore);
    });
};

export const getPlatform = () => {
  const platformMap = {
    wx: 'wechat', //企业微信
    dd: 'dingtalk', //钉钉
    webapp: 'webapp', //汇联易在线H5
    lark: 'feishu', //飞书
    welink: 'welink', //welink
    cd: 'cd', // 汇联易App
    yzj: 'yzj', //云之家
  };
  let h5Platform = getH5Platform();
  return platformMap[h5Platform] || null;
};

//企业微信自建应用的判断
export const getAgentId = () => {
  let agentId = getQueryString('agentId');
  let extraParams = getQueryString('extraParams');
  let loginType = getQueryString('loginType');
  //webapp嵌入企微客户待办的场景
  let ssoAgentId = null;
  try {
    if (loginType === 'sso' && extraParams) {
      extraParams = Base64.decode(extraParams);
      extraParams = JSON.parse(extraParams);
      ssoAgentId = extraParams.agentId;
    }
  } catch (e) {}
  return agentId || ssoAgentId;
};

/**
 * 获取重定向地址
 * @param platform 平台
 * @param multipleCloud 多云环境
 * @return {*}
 */
export function getRedirectUrl(platform, multipleCloud) {
  let iteration2Url = 'https://www.huilianyi.com/huilianyi-wechat/h5-iteration2/?';
  //专属云按迭代日划分地址
  const corpIdUrlMapping = {
    //中化蓝天
    wxa7e8d6b69ee20f1e: {
      appUrl: 'https://www.huilianyi.com/huilianyi-wechat/h5-iteration2/?',
      pcUrl: 'https://bx.sinochemlt.com?',
    },
    //国海证券
    wxa0e4ab03662250e6: {
      appUrl: 'https://www.huilianyi.com/huilianyi-wechat/h5-iteration2/?',
      pcUrl: 'https://console-ghzq.huilianyi.com?',
    },
    //国泰基金管理有限公司
    ww2018cca70c1f3bad: {
      appUrl: iteration2Url,
      pcUrl: 'https://hly.gtfund.com?',
    },
    //优刻得科技股份有限公司
    wx27aea8206f650b1e: {
      appUrl: iteration2Url,
      pcUrl: 'https://ubx.ucloudadmin.com?',
    },
    //比亚迪
    ww5614ccf1c02e6d99: {
      appUrl: iteration2Url,
      pcUrl: 'https://console.huilianyi.com?',
    },
    //B站
    wx0833ac9926284fa5: {
      appUrl: iteration2Url,
      pcUrl: 'https://expense.bilibili.co?',
    },
  };
  const environmentMapping = {
    dev: {
      appUrl: 'https://appcoredev.huilianyi.com/h5-core/?',
      pcUrl: 'http://106.15.26.10:10080',
    },
    uat: {
      appUrl: 'https://appcoreuat.huilianyi.com/h5-core/?',
      pcUrl: 'https://uat.huilianyi.com',
    },
    stage: {
      appUrl: 'https://appcorestage.huilianyi.com/h5-core/?',
      pcUrl: 'https://stage.huilianyi.com',
    },
    prod: {
      appUrl: 'https://www.huilianyi.com/huilianyi-wechat/h5-core/?',
      pcUrl: 'https://console.huilianyi.com',
    },
  };
  let locationUrl = window.location.href;
  let redirectUrl = environmentMapping.prod[platform];
  if (locationUrl.indexOf('dev.huilianyi.com') > -1) {
    redirectUrl = environmentMapping.dev[platform];
  } else if (locationUrl.indexOf('uat.huilianyi.com') > -1) {
    redirectUrl = environmentMapping.uat[platform];
  } else if (locationUrl.indexOf('stage.huilianyi.com') > -1) {
    redirectUrl = environmentMapping.stage[platform];
  } else if (
    locationUrl.indexOf('www.huilianyi.com/h5-core') > -1 ||
    locationUrl.indexOf('expensewebapp.bilibili.co') > -1
  ) {
    redirectUrl = environmentMapping.prod[platform];
    if (multipleCloud) {
      let corpId = getQueryString('corpId');
      let corpIdUrlInfo = corpIdUrlMapping[corpId];
      if (corpIdUrlInfo) {
        redirectUrl = corpIdUrlInfo[platform];
      }
    }
  }
  return redirectUrl;
}
